// extracted by mini-css-extract-plugin
export default {"container":"styles_container__tHeZa","cv":"styles_cv__-xMhv","cvIcon":"styles_cvIcon__2jIZT","cvText":"styles_cvText__Ifrqw"};